export const DashboardComponent = (prop: { data: any }) => {
  return prop.data.map((e, index) => {
    return (
      <div
        className="card flex flex-col overflow-hidden rounded-2xl p-0"
        key={index}
      >
        <div className="h-2/2 m-0 flex  w-full items-center bg-primary  text-white">
          {e.conectadas > 0 && (
            <div className="mx-auto flex w-1/2  flex-col tracking-wider">
              <p className="border-white text-center">Calificadas</p>
              <p className=" text-center text-[22px] ">{e.conectadas}</p>
            </div>
          )}
          {e.pendientes > 0 && (
            <div
              className={
                e.pendientes > 0 && e.conectadas > 0
                  ? "mx-auto flex w-1/2 flex-col border-l-2 tracking-wider"
                  : "mx-auto flex w-1/2 flex-col tracking-wider"
              }
            >
              <p className=" text-center">Pendientes</p>
              <p className="text-center text-[22px] ">{e.pendientes}</p>
            </div>
          )}
        </div>
        <div className="flex w-2/3 flex-col">
          <p className="pl-5 pt-4 text-[22px]">
            {e.nombreUsuario} {e.appUsuario} {e.apmUsuario}
          </p>
          <p className="mb-3 pl-5 font-bold">{e.username}</p>
        </div>
      </div>
    );
  });
};
